import { render } from "./ExamenImagerieLayout.vue?vue&type=template&id=0092a80e&lang=true"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__